import { IWebMessage } from 'src/app/common/interfaces/webmessage-interface';
import { ICombinedTransactionalSettings } from '../../interfaces/configuration/combined-transactional-settings.interface';

export abstract class AbstractCombinedConfigurationService {
  abstract getCombinedTransactionalSettings(
    routingNumber: string
  ): Promise<ICombinedTransactionalSettings | undefined>;

  abstract updateCombinedTransactionalSettings(
    settings: ICombinedTransactionalSettings
  ): Promise<IWebMessage | undefined>;
}
